// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LoginPage Styles */

.login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--background-light);
  position: relative;
}

/* Login Header */
.login-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2.5rem;
  z-index: 10;
}

.header-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--text-main);
}

.logo-icon {
  width: 32px;
  height: 32px;
  color: var(--primary);
}

.header-logo h2 {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-sub);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: color var(--transition-fast);
}

.back-link:hover {
  color: var(--primary);
}

.back-link .material-symbols-outlined {
  font-size: 20px;
}

/* Login Main */
.login-main {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem 2rem;
  position: relative;
}

.decorative-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.blur-circle {
  position: absolute;
  border-radius: 50%;
  background: var(--primary);
  opacity: 0.1;
  filter: blur(100px);
}

.blur-circle-1 {
  width: 40%;
  height: 40%;
  top: -10%;
  left: -5%;
}

.blur-circle-2 {
  width: 30%;
  height: 30%;
  top: 20%;
  right: -5%;
  background: #816bf5;
  opacity: 0.1;
  filter: blur(80px);
}

/* Login Card */
.login-card {
  width: 100%;
  max-width: 440px;
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);
  border: 1px solid var(--slate-200);
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.login-hero {
  height: 128px;
  background: linear-gradient(135deg, var(--primary) 0%, #7c3aed 100%);
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(55, 19, 236, 0.8), rgba(55, 19, 236, 0.4));
  mix-blend-mode: multiply;
}

.hero-icon {
  position: relative;
  z-index: 2;
  width: 64px;
  height: 64px;
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.hero-icon .material-symbols-outlined {
  font-size: 36px;
}

/* Login Form Container */
.login-form-container {
  padding: 1.5rem 2rem 2.5rem;
}

.login-header-text {
  text-align: center;
  margin-bottom: 2rem;
}

.login-header-text h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 0.5rem;
}

.login-header-text p {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

/* Form Styles */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.forgot-link {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--primary);
  text-decoration: none;
}

.forgot-link:hover {
  text-decoration: underline;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-wrapper .form-input {
  width: 100%;
  padding: 0.75rem 2.75rem 0.75rem 1rem;
  background-color: var(--slate-50);
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-lg);
  font-size: 0.9375rem;
  color: var(--text-main);
  transition: all var(--transition-fast);
}

.input-wrapper .form-input:focus {
  background-color: var(--surface-light);
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(99, 101, 241, 0.1);
  outline: none;
}

.password-toggle {
  position: absolute;
  right: 0.75rem;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--slate-400);
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color var(--transition-fast);
}

.password-toggle:hover {
  color: var(--text-sub);
}

.password-toggle .material-symbols-outlined {
  font-size: 20px;
}

.form-actions {
  padding-top: 0.5rem;
}

.submit-btn {
  width: 100%;
  height: 44px;
  padding: 0.625rem 1rem;
  font-weight: 500;
  transition: all var(--transition-fast);
}

.submit-btn:active:not(:disabled) {
  transform: scale(0.98);
}

/* Login Footer */
.login-footer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--slate-200);
  text-align: center;
}

.login-footer p {
  font-size: 0.75rem;
  color: var(--text-sub);
  margin: 0;
}

.support-link {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--primary);
  text-decoration: none;
}

.support-link:hover {
  text-decoration: underline;
}

/* Login Footer Bar */
.login-footer-bar {
  width: 100%;
  padding: 1rem;
  text-align: center;
  color: var(--text-sub);
  font-size: 0.875rem;
}

.login-footer-bar p {
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .login-header {
    padding: 1rem;
  }

  .back-link span {
    display: none;
  }

  .login-main {
    padding: 1rem;
    align-items: flex-start;
    padding-top: 6rem;
  }

  .login-card {
    max-width: 100%;
  }

  .login-form-container {
    padding: 1.5rem 1.25rem 2rem;
  }

  .blur-circle {
    filter: blur(60px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;EAC/B,0CAA0C;EAC1C,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oEAAoE;EACpE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sFAAsF;EACtF,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,iCAAiC;EACjC,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* LoginPage Styles */\n\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--background-light);\n  position: relative;\n}\n\n/* Login Header */\n.login-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 2.5rem;\n  z-index: 10;\n}\n\n.header-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--text-main);\n}\n\n.logo-icon {\n  width: 32px;\n  height: 32px;\n  color: var(--primary);\n}\n\n.header-logo h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.back-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.back-link:hover {\n  color: var(--primary);\n}\n\n.back-link .material-symbols-outlined {\n  font-size: 20px;\n}\n\n/* Login Main */\n.login-main {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem 2rem;\n  position: relative;\n}\n\n.decorative-bg {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.blur-circle {\n  position: absolute;\n  border-radius: 50%;\n  background: var(--primary);\n  opacity: 0.1;\n  filter: blur(100px);\n}\n\n.blur-circle-1 {\n  width: 40%;\n  height: 40%;\n  top: -10%;\n  left: -5%;\n}\n\n.blur-circle-2 {\n  width: 30%;\n  height: 30%;\n  top: 20%;\n  right: -5%;\n  background: #816bf5;\n  opacity: 0.1;\n  filter: blur(80px);\n}\n\n/* Login Card */\n.login-card {\n  width: 100%;\n  max-width: 440px;\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);\n  border: 1px solid var(--slate-200);\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n\n.login-hero {\n  height: 128px;\n  background: linear-gradient(135deg, var(--primary) 0%, #7c3aed 100%);\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom, rgba(55, 19, 236, 0.8), rgba(55, 19, 236, 0.4));\n  mix-blend-mode: multiply;\n}\n\n.hero-icon {\n  position: relative;\n  z-index: 2;\n  width: 64px;\n  height: 64px;\n  background-color: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.hero-icon .material-symbols-outlined {\n  font-size: 36px;\n}\n\n/* Login Form Container */\n.login-form-container {\n  padding: 1.5rem 2rem 2.5rem;\n}\n\n.login-header-text {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.login-header-text h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-main);\n  margin-bottom: 0.5rem;\n}\n\n.login-header-text p {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n/* Form Styles */\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.forgot-link {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--primary);\n  text-decoration: none;\n}\n\n.forgot-link:hover {\n  text-decoration: underline;\n}\n\n.input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-wrapper .form-input {\n  width: 100%;\n  padding: 0.75rem 2.75rem 0.75rem 1rem;\n  background-color: var(--slate-50);\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-lg);\n  font-size: 0.9375rem;\n  color: var(--text-main);\n  transition: all var(--transition-fast);\n}\n\n.input-wrapper .form-input:focus {\n  background-color: var(--surface-light);\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(99, 101, 241, 0.1);\n  outline: none;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 0.75rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--slate-400);\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color var(--transition-fast);\n}\n\n.password-toggle:hover {\n  color: var(--text-sub);\n}\n\n.password-toggle .material-symbols-outlined {\n  font-size: 20px;\n}\n\n.form-actions {\n  padding-top: 0.5rem;\n}\n\n.submit-btn {\n  width: 100%;\n  height: 44px;\n  padding: 0.625rem 1rem;\n  font-weight: 500;\n  transition: all var(--transition-fast);\n}\n\n.submit-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n/* Login Footer */\n.login-footer {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--slate-200);\n  text-align: center;\n}\n\n.login-footer p {\n  font-size: 0.75rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.support-link {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--primary);\n  text-decoration: none;\n}\n\n.support-link:hover {\n  text-decoration: underline;\n}\n\n/* Login Footer Bar */\n.login-footer-bar {\n  width: 100%;\n  padding: 1rem;\n  text-align: center;\n  color: var(--text-sub);\n  font-size: 0.875rem;\n}\n\n.login-footer-bar p {\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .login-header {\n    padding: 1rem;\n  }\n\n  .back-link span {\n    display: none;\n  }\n\n  .login-main {\n    padding: 1rem;\n    align-items: flex-start;\n    padding-top: 6rem;\n  }\n\n  .login-card {\n    max-width: 100%;\n  }\n\n  .login-form-container {\n    padding: 1.5rem 1.25rem 2rem;\n  }\n\n  .blur-circle {\n    filter: blur(60px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
